// test528
(528 && 0);
